(function () {
  'use strict';

  var STORAGE_KEY = 'bo_delivery_location_v1';
  var SESSION_KEY = 'bo_delivery_detected_v1';
  var TIME_ZONE = 'America/Bogota';
  var COMMERCE_CONFIG = window.BabyOnCommerceConfig || {};
  var FREE_SHIPPING_THRESHOLD = Number(COMMERCE_CONFIG.freeShippingThreshold) || 12990000;
  var FREE_SHIPPING_THRESHOLDS = COMMERCE_CONFIG.freeShippingThresholds || {};
  var CUTOFF_MINUTES = Number(COMMERCE_CONFIG.cutoffMinutes) || ((14 * 60) + 30);
  var LOCATION_TTL = 1000 * 60 * 60 * 24 * 45;
  var DETECTION_TIMEOUT = 4500;
  var LOCATION_DATA_KEY = 'bo_colombia_locations_v2';
  var LOCATION_DATA_TTL = 1000 * 60 * 60 * 24 * 30;
  var OFFICIAL_LOCATIONS_URL = 'https://www.datos.gov.co/resource/gdxc-w37w.json?$limit=5000';
  var FALLBACK_DEPARTMENTS_URL = 'https://raw.githubusercontent.com/proyecto26/colombia/master/departments.json';
  var FALLBACK_CITIES_URL = 'https://raw.githubusercontent.com/proyecto26/colombia/master/cities.json';

  var mainCities = [
    'medellin', 'cali', 'barranquilla', 'cartagena', 'bucaramanga',
    'pereira', 'manizales', 'armenia', 'cucuta', 'santa marta',
    'villavicencio', 'ibague', 'neiva', 'tunja', 'pasto', 'monteria',
    'valledupar', 'sincelejo', 'popayan'
  ];

  var state = {
    location: null,
    detecting: false,
    initialized: false,
    timer: null,
    lastCartAttributes: '',
    modalReturnFocus: null,
    locationOptions: [],
    mainLocationOptions: [],
    locationOptionsPromise: null,
    locationOptionsLoaded: false
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function titleCase(value) {
    var smallWords = {
      de: true, del: true, la: true, las: true, los: true,
      y: true, e: true, el: true, en: true, al: true
    };

    var words = String(value || '').trim().toLowerCase().split(/\s+/);
    var result = words.map(function (word, index) {
      if (word === '-') return word;

      return word.split('-').map(function (part, partIndex) {
        if (!part) return part;
        if ((index > 0 || partIndex > 0) && smallWords[part]) return part;
        return part.charAt(0).toUpperCase() + part.slice(1);
      }).join('-');
    }).join(' ');

    return result.replace(/D\.c\./g, 'D.C.');
  }

  function canonicalCity(city) {
    var cleaned = normalize(city);

    if (!cleaned) return '';
    if (cleaned.indexOf('bogota') !== -1 || cleaned.indexOf('distrito capital') !== -1) return 'Bogotá';
    if (cleaned.indexOf('soacha') !== -1) return 'Soacha';
    if (cleaned === 'medellin') return 'Medellín';
    if (cleaned === 'cali' || cleaned.indexOf('santiago de cali') !== -1) return 'Cali';
    if (cleaned === 'cucuta' || cleaned.indexOf('san jose de cucuta') !== -1) return 'Cúcuta';
    if (cleaned === 'ibague') return 'Ibagué';
    if (cleaned === 'monteria') return 'Montería';
    if (cleaned === 'popayan') return 'Popayán';

    return titleCase(city);
  }

  function classifyCity(city) {
    var cleaned = normalize(city);

    if (!cleaned) return 'unknown';
    if (cleaned.indexOf('bogota') !== -1 || cleaned.indexOf('distrito capital') !== -1) return 'bogota';
    if (cleaned.indexOf('soacha') !== -1) return 'soacha';
    if (mainCities.some(function (city) { return cleaned === city || cleaned.indexOf(city) !== -1; })) return 'main';
    return 'other';
  }

  function safeJsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function readStoredLocation() {
    var stored = safeJsonParse(window.localStorage.getItem(STORAGE_KEY));

    if (stored && stored.city && stored.savedAt && (Date.now() - stored.savedAt) < LOCATION_TTL) {
      stored.confirmed = true;
      return stored;
    }

    if (stored) window.localStorage.removeItem(STORAGE_KEY);

    var detected = safeJsonParse(window.sessionStorage.getItem(SESSION_KEY));
    if (detected && detected.city) {
      detected.confirmed = false;
      return detected;
    }

    return null;
  }

  function persistLocation(location) {
    if (!location || !location.city) return;

    var value = {
      city: canonicalCity(location.city),
      region: location.region || '',
      countryCode: location.countryCode || 'CO',
      zone: classifyCity(location.city),
      source: location.source || 'manual',
      confirmed: true,
      savedAt: Date.now()
    };

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    window.sessionStorage.removeItem(SESSION_KEY);
    state.location = value;
  }

  function persistDetectedLocation(location) {
    if (!location || !location.city) return;

    var value = {
      city: canonicalCity(location.city),
      region: location.region || '',
      countryCode: location.countryCode || 'CO',
      zone: classifyCity(location.city),
      source: location.source || 'ip',
      confirmed: false,
      savedAt: Date.now()
    };

    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(value));
    state.location = value;
  }

  function getBogotaParts(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date || new Date());

    var result = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    });

    return result;
  }

  function bogotaWallDate(date) {
    var parts = getBogotaParts(date);
    return new Date(Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    ));
  }

  function dateKey(date) {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0')
    ].join('-');
  }

  function addDays(date, days) {
    var copy = new Date(date.getTime());
    copy.setUTCDate(copy.getUTCDate() + days);
    return copy;
  }

  function nextOrSameMonday(date) {
    var day = date.getUTCDay();
    var daysToAdd = day === 1 ? 0 : ((8 - day) % 7);
    return addDays(date, daysToAdd);
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(Date.UTC(year, month - 1, day));
  }

  function colombianHolidays(year) {
    var holidaySet = new Set();

    function fixed(month, day) {
      holidaySet.add(dateKey(new Date(Date.UTC(year, month - 1, day))));
    }

    function mondayHoliday(month, day) {
      holidaySet.add(dateKey(nextOrSameMonday(new Date(Date.UTC(year, month - 1, day)))));
    }

    fixed(1, 1);
    mondayHoliday(1, 6);
    mondayHoliday(3, 19);
    fixed(5, 1);
    mondayHoliday(6, 29);
    mondayHoliday(7, 9);
    fixed(7, 20);
    fixed(8, 7);
    mondayHoliday(8, 15);
    mondayHoliday(10, 12);
    mondayHoliday(11, 1);
    mondayHoliday(11, 11);
    fixed(12, 8);
    fixed(12, 25);

    var easter = easterSunday(year);
    holidaySet.add(dateKey(addDays(easter, -3)));
    holidaySet.add(dateKey(addDays(easter, -2)));
    holidaySet.add(dateKey(nextOrSameMonday(addDays(easter, 39))));
    holidaySet.add(dateKey(nextOrSameMonday(addDays(easter, 60))));
    holidaySet.add(dateKey(nextOrSameMonday(addDays(easter, 68))));

    return holidaySet;
  }

  var holidayCache = {};

  function isHoliday(date) {
    var year = date.getUTCFullYear();
    if (!holidayCache[year]) holidayCache[year] = colombianHolidays(year);
    return holidayCache[year].has(dateKey(date));
  }

  function isOperationalDay(date) {
    return date.getUTCDay() !== 0 && !isHoliday(date);
  }

  /* Para entregas nacionales, “día hábil” se calcula de lunes a viernes.
   * Así, por ejemplo, dos días hábiles desde un viernes corresponden al martes. */
  function isNationalBusinessDay(date) {
    var day = date.getUTCDay();
    return day >= 1 && day <= 5 && !isHoliday(date);
  }

  function addBusinessDays(fromDate, businessDays) {
    var candidate = new Date(fromDate.getTime());
    var counted = 0;
    var guard = 0;

    while (counted < businessDays && guard < 40) {
      candidate = addDays(candidate, 1);
      if (isNationalBusinessDay(candidate)) counted += 1;
      guard += 1;
    }

    return candidate;
  }

  function nextOperationalDate(fromDate) {
    var candidate = addDays(fromDate, 1);
    var guard = 0;

    while (!isOperationalDay(candidate) && guard < 20) {
      candidate = addDays(candidate, 1);
      guard += 1;
    }

    return candidate;
  }

  function minutesOfDay(date) {
    return (date.getUTCHours() * 60) + date.getUTCMinutes();
  }

  function sameDayStatus(now) {
    var operational = isOperationalDay(now);
    var beforeCutoff = operational && minutesOfDay(now) < CUTOFF_MINUTES;

    if (beforeCutoff) {
      var cutoff = new Date(now.getTime());
      cutoff.setUTCHours(14, 30, 0, 0);
      return {
        sameDay: true,
        target: now,
        remainingMinutes: Math.max(1, Math.ceil((cutoff.getTime() - now.getTime()) / 60000))
      };
    }

    return {
      sameDay: false,
      target: nextOperationalDate(now),
      remainingMinutes: 0
    };
  }

  function formatCountdown(minutes) {
    if (minutes < 60) return minutes + ' min';

    var hours = Math.floor(minutes / 60);
    var rest = minutes % 60;
    return rest ? (hours + ' h ' + rest + ' min') : (hours + ' h');
  }

  function formatCalendarDate(target) {
    return new Intl.DateTimeFormat('es-CO', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC'
    }).format(target).replace(/,/g, '');
  }

  function formatShortCalendarDate(target) {
    return new Intl.DateTimeFormat('es-CO', {
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC'
    }).format(target).replace(/,/g, '');
  }

  function formatDeliveryDate(target, now) {
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var delivery = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate()));
    var diff = Math.round((delivery.getTime() - today.getTime()) / 86400000);
    var dateText = formatShortCalendarDate(delivery);

    if (diff === 1) return 'mañana, ' + dateText;
    return 'el ' + dateText;
  }

  function getPolicyZone(location) {
    if (!location || !location.city) return 'national';
    var city = normalize(location.city);
    var region = normalize(location.region);
    if (location.zone === 'bogota' || city.indexOf('bogota') !== -1) return 'bogota';
    if (location.zone === 'soacha' || city.indexOf('soacha') !== -1) return 'soacha';
    if (region.indexOf('cundinamarca') !== -1) return 'cundinamarca';
    return 'national';
  }

  function getThreshold(block, location) {
    var zone = getPolicyZone(location);
    var configured = Number(FREE_SHIPPING_THRESHOLDS[zone]);
    if (configured > 0) return configured;
    return Number(block && block.getAttribute('data-free-shipping-threshold')) || FREE_SHIPPING_THRESHOLD;
  }

  function getProductContext(block) {
    var section = block.closest('[data-section-type="product-template"]') || block.closest('.product-section');
    if (!section) return { amount: 0, available: true, quantity: 1, variant: null };

    var sectionId = block.getAttribute('data-section-id') || section.getAttribute('data-section-id');
    var jsonNode = document.getElementById('ProductJson-' + sectionId);
    var product = jsonNode ? safeJsonParse(jsonNode.textContent) : null;
    var selector = section.querySelector('[id^="MainProductSelect"], form[action*="/cart/add"] select[name="id"]');
    var selectedId = selector ? Number(selector.value) : 0;
    var variant = null;

    if (product && Array.isArray(product.variants)) {
      variant = product.variants.find(function (item) {
        return Number(item.id) === selectedId;
      }) || product.variants[0];
    }

    var quantityInput = section.querySelector('form[action*="/cart/add"] input[name="quantity"], .product-single__quantity input[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    var price = variant ? Number(variant.price) : (product ? Number(product.price) : 0);

    return {
      amount: price * quantity,
      available: variant ? variant.available !== false : true,
      quantity: quantity,
      variant: variant
    };
  }

  function buildPromise(location, amount, available, block, options) {
    options = options || {};
    var now = bogotaWallDate();
    var threshold = getThreshold(block, location);
    var freeShipping = amount >= threshold;
    var gap = Math.max(0, threshold - amount);
    var initialPolicyZone = getPolicyZone(location);
    var localCodFree = initialPolicyZone === 'bogota' || initialPolicyZone === 'soacha';
    var thresholdCopy = localCodFree
      ? 'Envío gratis desde ' + formatMoney(threshold) + '. También aplica a contraentrega local.'
      : 'Envío gratis con pago anticipado u online desde ' + formatMoney(threshold) + '.';
    var freePolicyCopy = localCodFree
      ? 'Envío gratis. En Bogotá y Soacha también aplica a contraentrega local.'
      : 'Envío gratis con pago anticipado u online. Contraentrega conserva costo de envío.';

    if (!location || !location.city || location.zone === 'unknown') {
      return {
        locationLabel: 'Indica tu ciudad',
        title: 'Calcula cuándo recibirías tu pedido',
        detail: options.cart ? 'Selecciona tu ciudad para ver la fecha estimada.' : 'Confirma tu ciudad en un solo paso.',
        secondary: '',
        freeShipping: freeShipping,
        deliveryLabel: '',
        zone: 'unknown',
        policyZone: getPolicyZone(location),
        gap: gap,
        threshold: threshold
      };
    }

    var zone = location.zone || classifyCity(location.city);
    var policyZone = getPolicyZone(location);
    var city = canonicalCity(location.city);

    if (!available && !options.cart) {
      return {
        locationLabel: 'Entrega en ' + city,
        title: 'Confirma disponibilidad y entrega',
        detail: 'Una asesora verificará la variante seleccionada.',
        secondary: freeShipping ? freePolicyCopy : thresholdCopy,
        freeShipping: freeShipping,
        deliveryLabel: 'Pendiente de disponibilidad',
        zone: zone,
        policyZone: policyZone,
        gap: gap,
        threshold: threshold
      };
    }

    if (zone === 'bogota' || zone === 'soacha') {
      var delivery = sameDayStatus(now);
      var title;
      var detail;
      var secondary;
      var deliveryLabel;

      if (delivery.sameDay) {
        title = 'Recíbelo hoy' + (freeShipping ? ' · Envío gratis' : '');
        var countdownCopy = 'Compra en ' + formatCountdown(delivery.remainingMinutes) + ' para recibirlo hoy.';
        detail = options.cart ? countdownCopy : (freeShipping ? countdownCopy : thresholdCopy);
        secondary = options.cart
          ? ''
          : (freeShipping ? freePolicyCopy : countdownCopy + ' Pedidos confirmados antes de las 2:30 p. m.');
        deliveryLabel = 'Hoy, ' + formatCalendarDate(now);
      } else {
        var formattedDate = formatDeliveryDate(delivery.target, now);
        title = 'Recíbelo ' + formattedDate + (freeShipping ? ' · Envío gratis' : '');
        var schedulingCopy = 'Entrega programada después de confirmar el pedido.';
        detail = options.cart ? schedulingCopy : (freeShipping ? schedulingCopy : thresholdCopy);
        secondary = options.cart ? '' : (freeShipping ? freePolicyCopy : schedulingCopy);
        deliveryLabel = formatCalendarDate(delivery.target);
        deliveryLabel = deliveryLabel.charAt(0).toUpperCase() + deliveryLabel.slice(1);
      }

      return {
        locationLabel: 'Entrega en ' + city,
        title: title,
        detail: detail,
        secondary: secondary,
        freeShipping: freeShipping,
        deliveryLabel: deliveryLabel,
        zone: zone,
        policyZone: policyZone,
        gap: gap,
        threshold: threshold
      };
    }

    /* Fecha aproximada:
     * ciudades principales: punto medio de 1–3 días hábiles = 2,
     * demás municipios (incluido Cundinamarca): punto medio de 2–4 = 3. */
    var estimatedBusinessDays = zone === 'main' ? 2 : 3;
    var estimatedDate = addBusinessDays(now, estimatedBusinessDays);
    var estimatedDateText = formatShortCalendarDate(estimatedDate);
    var estimatedDateLabel = formatCalendarDate(estimatedDate);
    estimatedDateLabel = estimatedDateLabel.charAt(0).toUpperCase() + estimatedDateLabel.slice(1);
    var habitualRange = zone === 'main'
      ? 'Tiempo habitual: 1 a 3 días hábiles.'
      : 'Tiempo habitual: 2 a 4 días hábiles.';

    return {
      locationLabel: 'Entrega en ' + city,
      title: 'Recíbelo aprox. el ' + estimatedDateText + (freeShipping ? ' · Envío gratis' : ''),
      detail: options.cart ? habitualRange : (freeShipping ? habitualRange : thresholdCopy),
      secondary: options.cart ? '' : (freeShipping ? freePolicyCopy : habitualRange),
      freeShipping: freeShipping,
      deliveryLabel: estimatedDateLabel,
      zone: zone,
      policyZone: policyZone,
      gap: gap,
      threshold: threshold
    };
  }

  function renderProductBlocks() {
    var blocks = document.querySelectorAll('[data-bo-delivery-promise]');

    blocks.forEach(function (block) {
      var context = getProductContext(block);
      var promise = buildPromise(state.location, context.amount, context.available, block);
      var locationNode = block.querySelector('[data-bo-delivery-location]');
      var titleNode = block.querySelector('[data-bo-delivery-title]');
      var detailNode = block.querySelector('[data-bo-delivery-detail]');
      var secondaryNode = block.querySelector('[data-bo-delivery-secondary]');
      var confirmNode = block.querySelector('[data-bo-location-confirm]');

      if (locationNode) locationNode.textContent = promise.locationLabel;
      if (titleNode) titleNode.textContent = promise.title;

      if (detailNode) {
        detailNode.textContent = promise.detail || '';
        detailNode.hidden = !promise.detail;
      }

      if (secondaryNode) {
        secondaryNode.textContent = promise.secondary || '';
        secondaryNode.hidden = !promise.secondary;
      }

      if (confirmNode) {
        confirmNode.hidden = !(state.location && !state.location.confirmed);
      }

      block.classList.toggle('bo-delivery-promise--free', promise.freeShipping);
      block.classList.toggle('bo-delivery-promise--unknown', promise.zone === 'unknown');
      block.setAttribute('data-bo-delivery-label', promise.deliveryLabel || '');
      block.setAttribute('data-bo-free-shipping', promise.freeShipping ? 'true' : 'false');
      block.setAttribute('data-free-shipping-threshold', String(promise.threshold || FREE_SHIPPING_THRESHOLD));
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0
    }).format(Math.max(0, cents) / 100)
      .replace(/\s/g, ' ')
      .replace(/\$\s+/g, '$');
  }

  function renderCartBlocks() {
    var blocks = document.querySelectorAll('[data-bo-cart-delivery]');

    blocks.forEach(function (block) {
      var total = Number(block.getAttribute('data-cart-total')) || 0;
      var threshold = getThreshold(block, state.location);
      var freeShipping = total >= threshold;
      var gap = Math.max(0, threshold - total);
      var percent = threshold > 0 ? Math.max(0, Math.min(100, (total / threshold) * 100)) : 100;
      var promise = buildPromise(state.location, total, true, block, { cart: true });
      var locationNode = block.querySelector('[data-bo-cart-delivery-location]');
      var titleNode = block.querySelector('[data-bo-cart-delivery-title]');
      var detailNode = block.querySelector('[data-bo-cart-delivery-detail]');
      var secondaryNode = block.querySelector('[data-bo-cart-delivery-secondary]');
      var progressTextNode = block.querySelector('[data-bo-cart-free-text]');
      var progressNoteNode = block.querySelector('[data-bo-cart-free-note]');
      var progressTrack = block.querySelector('[data-bo-cart-free-track]');
      var progressFill = block.querySelector('[data-bo-cart-free-fill]');
      var progressTruck = block.querySelector('[data-bo-cart-free-truck]');

      if (locationNode) locationNode.textContent = promise.locationLabel;
      if (titleNode) titleNode.textContent = promise.title;

      if (detailNode) {
        detailNode.textContent = promise.detail || '';
        detailNode.hidden = !promise.detail;
      }

      if (secondaryNode) {
        secondaryNode.textContent = promise.secondary || '';
        secondaryNode.hidden = !promise.secondary;
      }

      var cartPolicyZone = getPolicyZone(state.location);
      var cartLocalCodFree = cartPolicyZone === 'bogota' || cartPolicyZone === 'soacha';
      if (progressTextNode) {
        progressTextNode.innerHTML = freeShipping
          ? (cartLocalCodFree
              ? '<strong>¡Listo!</strong> Tienes <strong>envío gratis</strong>, también en contraentrega local.'
              : '<strong>¡Listo!</strong> Tienes <strong>envío gratis</strong> con pago anticipado u online.')
          : 'Te faltan <strong>' + formatMoney(gap) + '</strong> para obtener <strong>envío gratis</strong>' + (cartLocalCodFree ? '.' : ' con pago anticipado u online.');
      }

      if (progressNoteNode) {
        progressNoteNode.textContent = cartLocalCodFree
          ? 'En Bogotá y Soacha el beneficio también aplica a contraentrega local.'
          : 'Fuera de Bogotá y Soacha, la contraentrega conserva el costo de envío.';
      }

      if (progressFill) progressFill.style.width = percent.toFixed(2) + '%';
      if (progressTruck) progressTruck.style.left = 'calc(' + percent.toFixed(2) + '% - 11px)';

      if (progressTrack) {
        progressTrack.setAttribute('aria-valuemin', '0');
        progressTrack.setAttribute('aria-valuemax', String(threshold));
        progressTrack.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
        progressTrack.setAttribute('aria-label', freeShipping
          ? 'Beneficio de envío gratis alcanzado'
          : 'Progreso para obtener envío gratis');
      }

      block.hidden = false;
      block.classList.toggle('bo-cart-delivery--free', freeShipping);
      block.classList.toggle('bo-cart-delivery--unknown', promise.zone === 'unknown');
      block.setAttribute('data-bo-free-shipping', freeShipping ? 'true' : 'false');
      block.setAttribute('data-free-shipping-threshold', String(threshold));

      promise.freeShipping = freeShipping;
      promise.gap = gap;
      promise.threshold = threshold;

      if (state.location && state.location.confirmed) updateCartAttributes(promise);
    });
  }

  function renderAll() {
    renderProductBlocks();
    renderCartBlocks();
  }

  function updateCartAttributes(promise) {
    if (!state.location || !state.location.confirmed) return;

    var attributes = {
      'Ciudad de entrega': state.location.city,
      'Zona de entrega': state.location.zone,
      'Entrega estimada': promise.deliveryLabel || promise.detail,
      'Beneficio de envío': promise.freeShipping
        ? ((promise.policyZone === 'bogota' || promise.policyZone === 'soacha') ? 'Envío gratis; también aplica a contraentrega local' : 'Envío gratis con pago anticipado u online')
        : 'Calculado en el carrito o checkout'
    };

    var serialized = JSON.stringify(attributes);
    if (serialized === state.lastCartAttributes) return;

    state.lastCartAttributes = serialized;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {
      state.lastCartAttributes = '';
    });
  }

  function setLocation(location, confirmed) {
    var prepared = {
      city: canonicalCity(location.city),
      region: location.region || '',
      countryCode: location.countryCode || 'CO',
      zone: classifyCity(location.city),
      source: location.source || 'manual',
      confirmed: Boolean(confirmed),
      savedAt: Date.now()
    };

    if (confirmed) {
      persistLocation(prepared);
    } else {
      persistDetectedLocation(prepared);
    }

    renderAll();
    document.dispatchEvent(new CustomEvent('bo:location-changed', { detail: state.location }));
  }

  function confirmCurrentLocation() {
    if (!state.location || !state.location.city) return;
    state.location.confirmed = true;
    state.location.source = state.location.source || 'ip';
    persistLocation(state.location);
    renderAll();
    closeLocationModal();
    document.dispatchEvent(new CustomEvent('bo:location-changed', { detail: state.location }));
  }

  function getModal() {
    return document.querySelector('[data-bo-location-modal]');
  }

  function getLocationInput() {
    var modal = getModal();
    return modal ? modal.querySelector('[data-bo-location-input]') : null;
  }

  function normalizeLocationEntry(city, region) {
    city = canonicalCity(city);
    region = titleCase(region || '');

    if (!city) return null;
    if (normalize(city).indexOf('bogota') !== -1) {
      city = 'Bogotá';
      region = 'Bogotá D.C.';
    }

    return {
      city: city,
      region: region,
      citySearch: normalize(city),
      regionSearch: normalize(region),
      label: region && normalize(region) !== normalize(city)
        ? city + ', ' + region
        : city
    };
  }

  function dedupeLocationOptions(options) {
    var seen = {};

    return options.filter(function (entry) {
      if (!entry || !entry.city) return false;
      var key = normalize(entry.city) + '|' + normalize(entry.region);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label, 'es', { sensitivity: 'base' });
    });
  }

  function readCachedLocationOptions() {
    var cached = safeJsonParse(window.localStorage.getItem(LOCATION_DATA_KEY));
    if (!cached || !Array.isArray(cached.items) || !cached.savedAt) return [];

    if ((Date.now() - cached.savedAt) >= LOCATION_DATA_TTL) {
      window.localStorage.removeItem(LOCATION_DATA_KEY);
      return [];
    }

    return cached.items.map(function (entry) {
      return normalizeLocationEntry(entry.city, entry.region);
    }).filter(Boolean);
  }

  function cacheLocationOptions(options) {
    try {
      window.localStorage.setItem(LOCATION_DATA_KEY, JSON.stringify({
        savedAt: Date.now(),
        items: options.map(function (entry) {
          return { city: entry.city, region: entry.region };
        })
      }));
    } catch (error) {}
  }

  function fetchJson(url, timeoutMs) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, timeoutMs || 8000);

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'force-cache',
      referrerPolicy: 'no-referrer',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Location data unavailable');
      return response.json();
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function locationsFromBundledData(rows) {
    if (!Array.isArray(rows)) return [];

    return rows.map(function (row) {
      if (Array.isArray(row)) return normalizeLocationEntry(row[0], row[1]);
      return normalizeLocationEntry(row.city || row.name || '', row.region || row.department || '');
    }).filter(Boolean);
  }

  function locationsFromOfficialData(rows) {
    if (!Array.isArray(rows)) return [];

    return rows.map(function (row) {
      var city = row.nombre_municipio || row.municipio || row.nom_mpio ||
        row.nombre_del_municipio || row.mpio || row.city || '';
      var region = row.nombre_departamento || row.departamento || row.dpto ||
        row.nombre_del_departamento || row.department || '';
      return normalizeLocationEntry(city, region);
    }).filter(Boolean);
  }

  function locationsFromFallbackData(departmentsPayload, citiesPayload) {
    var departments = departmentsPayload && Array.isArray(departmentsPayload.data)
      ? departmentsPayload.data
      : [];
    var cities = citiesPayload && Array.isArray(citiesPayload.data)
      ? citiesPayload.data
      : [];
    var departmentMap = {};

    departments.forEach(function (department) {
      departmentMap[String(department.id)] = department.name || '';
    });

    return cities.map(function (city) {
      return normalizeLocationEntry(city.name, departmentMap[String(city.departmentId)] || '');
    }).filter(Boolean);
  }

  function getMainCityOptions() {
    if (state.mainLocationOptions.length) return state.mainLocationOptions;

    var modal = getModal();
    if (!modal) return [];

    state.mainLocationOptions = Array.prototype.map.call(
      modal.querySelectorAll('[data-bo-location-city-source] option'),
      function (option) {
        return normalizeLocationEntry(option.value, option.getAttribute('data-region') || '');
      }
    ).filter(Boolean);

    return state.mainLocationOptions;
  }

  function loadLocationOptions() {
    if (state.locationOptionsLoaded) return Promise.resolve(state.locationOptions);
    if (state.locationOptionsPromise) return state.locationOptionsPromise;

    var bundled = locationsFromBundledData(window.BabyOnColombiaLocations || []);
    if (bundled.length > 500) {
      state.locationOptions = dedupeLocationOptions(bundled.concat(getMainCityOptions()));
      state.locationOptionsLoaded = true;
      cacheLocationOptions(state.locationOptions);
      return Promise.resolve(state.locationOptions);
    }

    var cached = readCachedLocationOptions();
    if (cached.length > 500) {
      state.locationOptions = dedupeLocationOptions(cached);
      state.locationOptionsLoaded = true;
      return Promise.resolve(state.locationOptions);
    }

    state.locationOptionsPromise = fetchJson(OFFICIAL_LOCATIONS_URL, 9000)
      .then(function (rows) {
        var options = locationsFromOfficialData(rows);
        if (options.length < 500) throw new Error('Incomplete official location data');
        return options;
      })
      .catch(function () {
        return Promise.all([
          fetchJson(FALLBACK_DEPARTMENTS_URL, 9000),
          fetchJson(FALLBACK_CITIES_URL, 9000)
        ]).then(function (payloads) {
          return locationsFromFallbackData(payloads[0], payloads[1]);
        });
      })
      .then(function (options) {
        state.locationOptions = dedupeLocationOptions(options.concat(getMainCityOptions()));
        state.locationOptionsLoaded = state.locationOptions.length > 0;
        if (state.locationOptionsLoaded) cacheLocationOptions(state.locationOptions);
        return state.locationOptions;
      })
      .catch(function () {
        state.locationOptions = getMainCityOptions().slice();
        state.locationOptionsLoaded = false;
        return state.locationOptions;
      })
      .finally(function () {
        state.locationOptionsPromise = null;
      });

    return state.locationOptionsPromise;
  }

  function getCityOptions() {
    return state.locationOptions.length ? state.locationOptions : getMainCityOptions();
  }

  function scoreLocationOption(entry, query) {
    if (!query) return 99;
    if (entry.citySearch === query) return 0;
    if (entry.citySearch.indexOf(query) === 0) return 1;
    if (entry.citySearch.split(' ').some(function (word) { return word.indexOf(query) === 0; })) return 2;
    if (entry.citySearch.indexOf(query) !== -1) return 3;
    if (entry.regionSearch === query) return 4;
    if (entry.regionSearch.indexOf(query) === 0) return 5;
    if (entry.regionSearch.indexOf(query) !== -1) return 6;
    return 99;
  }

  function hideCitySuggestions(input) {
    var modal = getModal();
    if (!modal) return;

    var suggestions = modal.querySelector('[data-bo-location-suggestions]');
    if (suggestions) suggestions.hidden = true;
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function updateLocationClearButton(input) {
    var modal = getModal();
    if (!modal) return;

    var clearButton = modal.querySelector('[data-bo-location-clear]');
    if (clearButton) clearButton.hidden = !input || !input.value;
  }

  function renderCitySuggestions(input) {
    var modal = getModal();
    if (!modal || !input) return;

    var suggestions = modal.querySelector('[data-bo-location-suggestions]');
    if (!suggestions) return;

    var query = normalize(input.value);
    var options;

    if (!query) {
      /* Sin texto solo mostramos ciudades principales para no crear una lista extensa. */
      options = getMainCityOptions().slice(0, 12);
    } else {
      options = getCityOptions().map(function (entry) {
        return { entry: entry, score: scoreLocationOption(entry, query) };
      }).filter(function (item) {
        return item.score < 99;
      }).sort(function (a, b) {
        if (a.score !== b.score) return a.score - b.score;
        return a.entry.label.localeCompare(b.entry.label, 'es', { sensitivity: 'base' });
      }).slice(0, 12).map(function (item) {
        return item.entry;
      });
    }

    suggestions.innerHTML = '';

    options.forEach(function (entry) {
      var option = document.createElement('button');
      var cityName = document.createElement('strong');
      var regionName = document.createElement('small');

      option.type = 'button';
      option.className = 'bo-location-modal__suggestion';
      option.setAttribute('role', 'option');
      option.setAttribute('data-bo-location-suggestion-city', entry.city);
      option.setAttribute('data-bo-location-suggestion-region', entry.region || '');

      cityName.textContent = entry.city;
      option.appendChild(cityName);

      if (entry.region && normalize(entry.region) !== normalize(entry.city)) {
        regionName.textContent = entry.region;
        option.appendChild(regionName);
      }

      suggestions.appendChild(option);
    });

    suggestions.hidden = options.length === 0;
    input.setAttribute('aria-expanded', options.length ? 'true' : 'false');
    updateLocationClearButton(input);
    scheduleLocationViewportUpdate();
  }

  function showCitySuggestions(input) {
    if (!input) return;

    renderCitySuggestions(input);

    /* La lista completa se carga en segundo plano. Al terminar, actualizamos
     * las coincidencias sin cerrar el teclado ni mover el modal. */
    loadLocationOptions().then(function () {
      var modal = getModal();
      if (!modal || modal.hidden || !document.documentElement.contains(input)) return;
      renderCitySuggestions(input);
    });
  }

  function focusLocationInput(input, selectExisting) {
    if (!input) return;

    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }

    if (selectExisting && input.value) {
      window.setTimeout(function () {
        try { input.setSelectionRange(0, input.value.length); } catch (error) {}
      }, 0);
    }

    showCitySuggestions(input);
  }

  function updateLocationModalViewport() {
    var modal = getModal();
    if (!modal) return;

    var viewport = window.visualViewport;
    var viewportHeight = viewport ? viewport.height : window.innerHeight;
    var viewportTop = viewport ? viewport.offsetTop : 0;
    var input = getLocationInput();
    var suggestions = modal.querySelector('[data-bo-location-suggestions]');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var inputFocused = Boolean(input && document.activeElement === input);

    modal.style.setProperty('--bo-location-viewport-height', Math.max(240, Math.round(viewportHeight)) + 'px');
    modal.style.setProperty('--bo-location-viewport-top', Math.max(0, Math.round(viewportTop)) + 'px');
    modal.classList.toggle('bo-location-modal--keyboard-open', Boolean(isMobile && inputFocused));

    if (isMobile && inputFocused && input) {
      window.requestAnimationFrame(function () {
        var currentViewport = window.visualViewport;
        var visibleBottom = currentViewport
          ? currentViewport.offsetTop + currentViewport.height
          : window.innerHeight;
        var inputRect = input.getBoundingClientRect();
        var availableHeight = Math.floor(visibleBottom - inputRect.bottom - 10);
        /* Aprovecha todo el espacio visible hasta el teclado. La lista conserva
         * su propio scroll cuando existen muchas coincidencias. */
        var suggestionHeight = Math.max(110, availableHeight);

        modal.style.setProperty('--bo-location-suggestions-height', suggestionHeight + 'px');

        var dialog = modal.querySelector('.bo-location-modal__dialog');
        if (dialog) dialog.scrollTop = 0;
      });
    } else {
      modal.style.removeProperty('--bo-location-suggestions-height');
    }

    if (suggestions && !suggestions.hidden && inputFocused) {
      suggestions.scrollTop = 0;
    }
  }

  function scheduleLocationViewportUpdate() {
    window.requestAnimationFrame(updateLocationModalViewport);
    window.setTimeout(updateLocationModalViewport, 80);
    window.setTimeout(updateLocationModalViewport, 260);
  }

  function setModalStatus(message, isError) {
    var modal = getModal();
    if (!modal) return;

    var status = modal.querySelector('[data-bo-location-status]');
    if (!status) return;

    status.textContent = message || '';
    status.hidden = !message;
    status.classList.toggle('bo-location-modal__status--error', Boolean(isError));
  }

  function openLocationModal(trigger) {
    var modal = getModal();
    if (!modal) return;

    /* La base completa de municipios pesa más de 40 KiB. No se descarga al
       abrir una página: se solicita únicamente cuando el cliente va a usar
       el selector de ciudad. El modal puede abrir de inmediato y las opciones
       se incorporan en cuanto termina la carga. */
    if (window.BabyOnPerformance && typeof window.BabyOnPerformance.loadLocations === 'function') {
      window.BabyOnPerformance.loadLocations()
        .then(loadLocationOptions)
        .catch(function () { loadLocationOptions(); });
    } else {
      loadLocationOptions();
    }

    state.modalReturnFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('bo-location-modal-open');
    document.body.classList.add('bo-location-modal-open');
    setModalStatus('', false);
    scheduleLocationViewportUpdate();

    var input = modal.querySelector('[data-bo-location-input]');
    if (input) {
      input.value = state.location && state.location.city ? state.location.city : '';
      updateLocationClearButton(input);
      hideCitySuggestions(input);

      /* En pantallas táctiles evitamos el autofoco: iOS abre el teclado y puede
       * ampliar la página antes de que el cliente toque el campo. En computador
       * conservamos el autofoco para una experiencia más rápida. */
      var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (!coarsePointer) {
        window.setTimeout(function () { focusLocationInput(input, true); }, 60);
      }
    }
  }

  function closeLocationModal() {
    var modal = getModal();
    if (!modal || modal.hidden) return;

    var input = modal.querySelector('[data-bo-location-input]');
    hideCitySuggestions(input);
    if (input) delete input.dataset.boTouched;

    modal.hidden = true;
    modal.classList.remove('bo-location-modal--keyboard-open');
    modal.style.removeProperty('--bo-location-viewport-height');
    modal.style.removeProperty('--bo-location-viewport-top');
    modal.style.removeProperty('--bo-location-suggestions-height');
    document.documentElement.classList.remove('bo-location-modal-open');
    document.body.classList.remove('bo-location-modal-open');

    if (state.modalReturnFocus && typeof state.modalReturnFocus.focus === 'function') {
      state.modalReturnFocus.focus();
    }
  }

  function detectByIp() {
    if (state.detecting || state.location) return Promise.resolve(state.location);

    state.detecting = true;
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, DETECTION_TIMEOUT);

    return fetch('https://ipapi.co/json/', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Location service unavailable');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.city || (data.country_code && data.country_code !== 'CO')) {
          throw new Error('Location not found');
        }

        setLocation({
          city: data.city,
          region: data.region || '',
          countryCode: data.country_code || 'CO',
          source: 'ip'
        }, false);

        return state.location;
      })
      .catch(function () {
        renderAll();
        return null;
      })
      .finally(function () {
        window.clearTimeout(timeout);
        state.detecting = false;
      });
  }

  function reverseGeocode(latitude, longitude) {
    var url = 'https://api.bigdatacloud.net/data/reverse-geocode-client' +
      '?latitude=' + encodeURIComponent(latitude) +
      '&longitude=' + encodeURIComponent(longitude) +
      '&localityLanguage=es';

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      referrerPolicy: 'no-referrer'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Reverse geocoding unavailable');
        return response.json();
      })
      .then(function (data) {
        var city = data.city || data.locality || data.principalSubdivision;
        if (!city) throw new Error('City not found');

        return {
          city: city,
          region: data.principalSubdivision || '',
          countryCode: data.countryCode || 'CO',
          source: 'gps'
        };
      });
  }

  function useDeviceLocation(button) {
    if (!navigator.geolocation) {
      setModalStatus('Tu navegador no permite usar la ubicación. Escribe tu ciudad arriba.', true);
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');
    setModalStatus('Identificando tu ciudad…', false);

    navigator.geolocation.getCurrentPosition(
      function (position) {
        reverseGeocode(position.coords.latitude, position.coords.longitude)
          .then(function (location) {
            setLocation(location, true);
            closeLocationModal();
          })
          .catch(function () {
            setModalStatus('No pudimos identificar la ciudad. Escríbela arriba para continuar.', true);
          })
          .finally(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
          });
      },
      function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        setModalStatus('No fue posible usar la ubicación. Puedes escribir tu ciudad arriba.', true);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000
      }
    );
  }

  function getProductSnapshot(block) {
    block = block || document.querySelector('[data-bo-delivery-promise]');

    var context = block
      ? getProductContext(block)
      : { amount: 0, available: true, quantity: 1, variant: null };
    var promise = buildPromise(state.location, context.amount, context.available, block);

    return {
      location: state.location ? Object.assign({}, state.location) : null,
      context: {
        amount: context.amount,
        available: context.available,
        quantity: context.quantity,
        variant: context.variant
      },
      promise: Object.assign({}, promise)
    };
  }

  function getCartSnapshot(amount) {
    amount = Math.max(0, Number(amount || 0));
    var promise = buildPromise(state.location, amount, true, null, { cart: true });
    return {
      location: state.location ? Object.assign({}, state.location) : null,
      context: { amount: amount, available: true },
      promise: Object.assign({}, promise)
    };
  }

  function getWhatsappSummary() {
    if (!state.location || !state.location.city) return '';

    var block = document.querySelector('[data-bo-delivery-promise]');
    var context = block ? getProductContext(block) : { amount: 0, available: true };
    var promise = buildPromise(state.location, context.amount, context.available, block);
    var lines = [
      '',
      'Ubicación seleccionada: ' + state.location.city,
      'Entrega estimada: ' + (promise.deliveryLabel || promise.detail)
    ];

    if (promise.freeShipping) lines.push('Beneficio mostrado: ' + ((promise.policyZone === 'bogota' || promise.policyZone === 'soacha') ? 'Envío gratis; también aplica a contraentrega local' : 'Envío gratis con pago anticipado u online'));
    if (!state.location.confirmed) lines.push('Ubicación pendiente de confirmación');

    return '\n' + lines.join('\n');
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var citySuggestion = event.target.closest('[data-bo-location-suggestion-city]');
      if (citySuggestion) {
        event.preventDefault();
        var selectedCity = citySuggestion.getAttribute('data-bo-location-suggestion-city');
        var selectedRegion = citySuggestion.getAttribute('data-bo-location-suggestion-region') || '';
        if (selectedCity) {
          setLocation({
            city: selectedCity,
            region: selectedRegion,
            source: 'manual',
            countryCode: 'CO'
          }, true);
          closeLocationModal();
        }
        return;
      }

      var clearButton = event.target.closest('[data-bo-location-clear]');
      if (clearButton) {
        event.preventDefault();
        var clearInput = getLocationInput();
        if (clearInput) {
          clearInput.value = '';
          updateLocationClearButton(clearInput);
          focusLocationInput(clearInput, false);
        }
        return;
      }

      var manualInput = event.target.closest('[data-bo-location-input]');
      if (manualInput) {
        /* Un solo toque debe enfocar y permitir reemplazar la ciudad actual. */
        focusLocationInput(manualInput, !manualInput.dataset.boTouched);
        manualInput.dataset.boTouched = 'true';
        scheduleLocationViewportUpdate();
        return;
      }

      var changeButton = event.target.closest('[data-bo-location-change], [data-bo-location-confirm-change], [data-bo-cart-location-change]');
      if (changeButton) {
        event.preventDefault();
        openLocationModal(changeButton);
        return;
      }

      var confirmButton = event.target.closest('[data-bo-location-confirm-yes]');
      if (confirmButton) {
        event.preventDefault();
        confirmCurrentLocation();
        return;
      }

      var closeButton = event.target.closest('[data-bo-location-close]');
      if (closeButton) {
        event.preventDefault();
        closeLocationModal();
        return;
      }

      var gpsButton = event.target.closest('[data-bo-location-gps]');
      if (gpsButton) {
        event.preventDefault();
        useDeviceLocation(gpsButton);
        return;
      }

      if (event.target.closest('.qty-adjust, .js-qty__adjust--minus, .js-qty__adjust--plus')) {
        window.setTimeout(renderAll, 80);
        window.setTimeout(renderAll, 250);
      }
    });

    document.addEventListener('input', function (event) {
      if (event.target.matches('input[name="quantity"], .qty-input')) {
        window.setTimeout(renderAll, 0);
      }

      if (event.target.matches('[data-bo-location-input]')) {
        updateLocationClearButton(event.target);
        showCitySuggestions(event.target);
        setModalStatus('', false);
      }
    });

    document.addEventListener('focusin', function (event) {
      if (event.target.matches('[data-bo-location-input]')) {
        showCitySuggestions(event.target);
        scheduleLocationViewportUpdate();
      }
    });

    document.addEventListener('focusout', function (event) {
      if (!event.target.matches('[data-bo-location-input]')) return;

      window.setTimeout(function () {
        var modal = getModal();
        if (!modal || !modal.contains(document.activeElement)) {
          hideCitySuggestions(event.target);
        }
        scheduleLocationViewportUpdate();
      }, 140);
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[id^="MainProductSelect"], .single-option-selector__radio, select[name="id"]')) {
        window.setTimeout(renderAll, 0);
        window.setTimeout(renderAll, 180);
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-bo-location-form]');
      if (!form) return;

      event.preventDefault();
      var input = form.querySelector('[data-bo-location-input]');
      var city = input ? input.value.trim() : '';

      if (!city || city.length < 2) {
        setModalStatus('Escribe una ciudad o municipio válido.', true);
        if (input) input.focus();
        return;
      }

      var normalizedInput = normalize(city);
      var exactMatches = getCityOptions().filter(function (entry) {
        return entry.citySearch === normalizedInput || normalize(entry.label) === normalizedInput;
      });
      if (exactMatches.length > 1) {
        setModalStatus('Selecciona el municipio y departamento correctos en la lista.', true);
        showCitySuggestions(input);
        return;
      }

      var matchedLocation = exactMatches.length === 1 ? exactMatches[0] : null;

      setLocation({
        city: matchedLocation ? matchedLocation.city : city,
        region: matchedLocation ? matchedLocation.region : '',
        source: 'manual',
        countryCode: 'CO'
      }, true);
      closeLocationModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeLocationModal();
    });

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(renderAll, 80);
    });

    document.addEventListener('bo:cart-updated', function () {
      window.setTimeout(renderCartBlocks, 50);
    });

    if (window.jQuery) {
      window.jQuery(document).on('variantChange.boDelivery', '[data-section-type="product-template"]', function () {
        window.setTimeout(renderAll, 0);
      });

      window.jQuery('body').on('ajaxCart.afterCartLoad.boDelivery', function () {
        window.setTimeout(renderCartBlocks, 50);
      });
    }

    window.addEventListener('resize', scheduleLocationViewportUpdate, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleLocationViewportUpdate, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleLocationViewportUpdate, { passive: true });
    }

    var cartContainer = document.getElementById('CartContainer');
    if (cartContainer && typeof MutationObserver !== 'undefined') {
      /* El tema reemplaza el formulario completo como hijo directo de CartContainer.
         Observar todo el subárbol provoca ciclos cuando renderCartBlocks actualiza texto. */
      new MutationObserver(function () {
        window.setTimeout(renderCartBlocks, 20);
      }).observe(cartContainer, { childList: true, subtree: false });
    }
  }

  function startRefreshTimer() {
    if (state.timer) {
      window.clearInterval(state.timer);
      state.timer = null;
    }
    if (document.hidden) return;
    state.timer = window.setInterval(renderAll, 30000);
  }

  function init() {
    if (state.initialized) return;
    state.initialized = true;
    state.location = readStoredLocation();
    state.lastCartAttributes = '';

    bindEvents();
    renderAll();

    /* La detección aproximada por IP se conserva, pero deja de competir con
       la primera pintura. Solo se intenta cuando el bloque de entrega realmente
       entra en pantalla y el navegador ya tuvo oportunidad de terminar el trabajo
       crítico. Si el cliente elige una ciudad antes, nunca se ejecuta. */
    if (!state.location) {
      var detectionTarget = document.querySelector('[data-bo-delivery-promise]');
      var requestDetection = function () {
        if (state.location || document.hidden) return;
        var run = function () { if (!state.location) detectByIp(); };
        if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 3500 });
        else window.setTimeout(run, 1800);
      };

      if (detectionTarget && 'IntersectionObserver' in window) {
        var detectionObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          detectionObserver.disconnect();
          requestDetection();
        }, { rootMargin: '0px 0px 80px 0px' });
        detectionObserver.observe(detectionTarget);
      }
    }

    startRefreshTimer();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) renderAll();
      startRefreshTimer();
    });
  }

  window.BabyOnDelivery = {
    getState: function () {
      return {
        location: state.location ? Object.assign({}, state.location) : null
      };
    },
    getWhatsappSummary: getWhatsappSummary,
    getProductSnapshot: getProductSnapshot,
    getCartSnapshot: getCartSnapshot,
    openLocation: openLocationModal,
    render: renderAll,
    confirmLocation: confirmCurrentLocation,
    _test: {
      easterSunday: easterSunday,
      colombianHolidays: colombianHolidays,
      isOperationalDay: isOperationalDay,
      nextOperationalDate: nextOperationalDate,
      isNationalBusinessDay: isNationalBusinessDay,
      addBusinessDays: addBusinessDays,
      sameDayStatus: sameDayStatus,
      formatDeliveryDate: formatDeliveryDate,
      buildPromise: buildPromise,
      classifyCity: classifyCity
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
